import { IProvider, ISlot } from 'constants/types';

import { useProviders } from 'hooks/useProviders';

import { Loader } from 'common';
import { Layout } from 'components/layout';
import { HeaderProviderById } from './header';
import { ProvidersLine, SlotsLineProvider } from './lines';

import { CustomMetadata } from 'components/metadata';
import { allMetadata } from 'constants/metadata';
import { useSlotsByProviderIdQuery } from 'hooks/api/slots';
import { getItemIdentifier } from 'utils/slug';
import styles from './styles.module.css';

type ProviderPageByIdProps = {
  provider: IProvider;
  initialSlots?: ISlot[];
  initialOtherProviders?: IProvider[];
  initialProvidersCount?: string | number;
};

function normalizeSlots(data: unknown): ISlot[] {
  if (Array.isArray(data)) {
    return data;
  }

  if (
    data &&
    typeof data === 'object' &&
    Array.isArray((data as { results?: unknown }).results)
  ) {
    return (data as { results: ISlot[] }).results;
  }

  return [];
}

export const ProviderPageById = ({
  provider,
  initialSlots = [],
  initialOtherProviders = [],
  initialProvidersCount = '',
}: ProviderPageByIdProps) => {
  const { data: slotsData, isFetching: isSlotsFetching } =
    useSlotsByProviderIdQuery({
      id: provider?._id,
    });
  const { results, count, isFetching: isProvidersFetching } = useProviders();

  const fetchedSlots = normalizeSlots(slotsData);
  const slots = fetchedSlots.length ? fetchedSlots : initialSlots;

  const providerId = getItemIdentifier(provider);
  const otherProviders = (results.length ? results : initialOtherProviders)
    .filter((item) => getItemIdentifier(item) !== providerId)
    .slice(0, 8);

  const providersCount = count ?? initialProvidersCount ?? '';
  const showSlotsLoader =
    isSlotsFetching && !slots.length && !initialSlots.length;

  return (
    <div className={styles.container}>
      <CustomMetadata metadata={allMetadata.provider(provider)} />
      <Layout hasFooter isSearchInputMobileVisible>
        <main className={styles.main}>
          <HeaderProviderById data={provider} />
          {showSlotsLoader ? <Loader /> : <SlotsLineProvider data={slots} />}
          {isProvidersFetching && !otherProviders.length ? (
            <Loader template="fitContent" />
          ) : (
            <ProvidersLine
              data={otherProviders}
              count={String(providersCount ?? '')}
            />
          )}
        </main>
      </Layout>
    </div>
  );
};
